import React from "react";
import ct from "class-types.macro";
import Cookie from "js-cookie";
interface Props {
  toggleSpotlightBanner: (disabled: boolean) => void;
  isGoodBetterBest?: boolean;
}
const DismissButton = ({
  toggleSpotlightBanner,
  isGoodBetterBest = false
}: Props) => {
  const handleDismiss = () => {
    if (isGoodBetterBest) {
      Cookie.set("doNotShowGBB", "true");
    }
    toggleSpotlightBanner(false);
  };
  return <button onClick={() => handleDismiss()} type="button" className={ct("bg-transparent", "border-none", "cursor-pointer", "inline-flex", "items-center", "text-xs", "mr-2", "mt-2-1/2", "absolute", "top-0", "right-0", "text-white", "hover:text-gray-100", "lt:text-2xs", "lt:mt-1", "lt:mr-1", "lt:text-gray-600", "lt:hover:text-gray-800")} data-sentry-component="DismissButton" data-sentry-source-file="index.tsx">
      <svg className={ct("h-3", "mr-1/2", "w-3")} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-sentry-element="svg" data-sentry-source-file="index.tsx">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      </svg>
      Dismiss
    </button>;
};
export default DismissButton;